/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { CloudAssetIntegrationSettings } from './cloud-asset-integration-settings';

/**
 * A cloud asset integration.
 * @export
 * @interface CloudAssetIntegration
 */
export interface CloudAssetIntegration {
    /**
     * The creation time.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'createTime'?: string;
    /**
     * The integration status.
     * @type {boolean}
     * @memberof CloudAssetIntegration
     */
    'enabled'?: boolean;
    /**
     * The ID of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'id'?: string;
    /**
     * The name of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'name'?: string;
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'organizationId'?: string;
    /**
     * The cloud provider.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'provider'?: CloudAssetIntegrationProviderEnum;
    /**
     * Scope of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'scope'?: CloudAssetIntegrationScopeEnum;
    /**
     * The settings for the cloud asset integration.
     * @type {CloudAssetIntegrationSettings}
     * @memberof CloudAssetIntegration
     */
    'settings'?: CloudAssetIntegrationSettings;
    /**
     * The state of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'state'?: CloudAssetIntegrationStateEnum;
    /**
     * The update time.
     * @type {string}
     * @memberof CloudAssetIntegration
     */
    'updateTime'?: string;
}

export const CloudAssetIntegrationProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;

export type CloudAssetIntegrationProviderEnum = typeof CloudAssetIntegrationProviderEnum[keyof typeof CloudAssetIntegrationProviderEnum];
export const CloudAssetIntegrationScopeEnum = {
    CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED: 'CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED',
    ALL: 'ALL',
    AWS_COMMITMENTS: 'AWS_COMMITMENTS',
    AZURE_COMMITMENTS: 'AZURE_COMMITMENTS',
    ALL_MINIMAL_PERMISSIONS: 'ALL_MINIMAL_PERMISSIONS',
    AWS_AI_SERVICES: 'AWS_AI_SERVICES',
    GCP_COMMITMENTS: 'GCP_COMMITMENTS',
    DBO: 'DBO'
} as const;

export type CloudAssetIntegrationScopeEnum = typeof CloudAssetIntegrationScopeEnum[keyof typeof CloudAssetIntegrationScopeEnum];
export const CloudAssetIntegrationStateEnum = {
    STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
    ACTIVE: 'ACTIVE',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    PENDING: 'PENDING',
    DEGRADED: 'DEGRADED',
    FAILED: 'FAILED',
    DEGRADED_CREDENTIALS: 'DEGRADED_CREDENTIALS',
    DISABLED: 'DISABLED'
} as const;

export type CloudAssetIntegrationStateEnum = typeof CloudAssetIntegrationStateEnum[keyof typeof CloudAssetIntegrationStateEnum];


